var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.4927 16.4534H11.7984C11.2429 16.4534 10.791 16.9124 10.791 17.4767C10.791 18.0422 11.2429 18.5001 11.7984 18.5001H17.4927C18.0483 18.5001 18.5001 18.0422 18.5001 17.4767C18.5001 16.9124 18.0483 16.4534 17.4927 16.4534Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80902 4.40385L13.2049 8.76394C13.335 8.86821 13.3573 9.05956 13.2557 9.19286L6.85874 17.5282C6.45662 18.0431 5.86402 18.3344 5.22908 18.3452L1.73696 18.3882C1.55071 18.3903 1.38775 18.2613 1.34542 18.0764L0.551755 14.6258C0.414186 13.9915 0.551755 13.3358 0.953878 12.8306L7.38256 4.45545C7.48627 4.32108 7.6778 4.29743 7.80902 4.40385Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.6203 6.16544L14.5801 7.46401C14.4753 7.59623 14.2869 7.61773 14.1568 7.51238C12.8922 6.48901 9.65405 3.86285 8.75563 3.13509C8.62441 3.02759 8.60642 2.83625 8.71224 2.70295L9.71543 1.45706C10.6255 0.285337 12.2128 0.177839 13.4933 1.19906L14.9642 2.37078C15.5674 2.84377 15.9695 3.46726 16.1071 4.12299C16.2658 4.8443 16.0965 5.5527 15.6203 6.16544Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.822382b771787efabef95d820cdb9ee4.svg";
export { ForwardRef as ReactComponent };